import { styled } from '@mui/material/styles'

export const Panel = styled('div', {
  name: 'Panel',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`
